export default __webpack_public_path__ + "static/img/share.3b94d63.jpg";